<nz-modal
    [nzVisible]="isVisible()"
    [nzTitle]="'Update or Confirm Your Location'"
    [nzWidth]="900"
    [nzClosable]="false"
    [nzMaskClosable]="false"
    [nzKeyboard]="false"
    [nzCentered]="true"
    [nzOkText]="'Save Location'"
    [nzCancelText]="'Cancel For Now'"
    [nzOkDisabled]="!initialLocation.latitude || !initialLocation.longitude"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleSave()"
    >
    <ng-container *nzModalContent>
        <nz-alert 
            nzType="info" 
            nzMessage="Location Update Required"
            nzDescription="Your current location information needs to be updated or confirmed. Please select your location on the map below."
            [nzCloseable]="false"
            nzShowIcon>
        </nz-alert>
        
        <div style="margin-top: 16px; margin-bottom: 8px;">
            <strong>Select Your Location:</strong>
        </div>
        
        <app-map-select
            [mapMarkerLocation]="initialLocation"
            (locationSelected)="onLocationSelected($event)">
        </app-map-select>
        
        @if (initialLocation.latitude && initialLocation.longitude) {
            <div style="margin-top: 12px; padding: 8px; background-color: #f0f2f5; border-radius: 4px;">
                <small>
                    <strong>Selected coordinates:</strong> 
                    {{ initialLocation.latitude.toFixed(6) }}, {{ initialLocation.longitude.toFixed(6) }}
                </small>
            </div>
        }
    </ng-container>
</nz-modal>